export const CHAPI_FIELDS = [
  {
    key: "vitals",
    label: "Vitals",
    aliases: ["vitals"],
    tooltip:
      "Pulls the patient's most recent vital signs from CPRS into the note. Click the checkbox to include vitals in the note. A refresh vitals option is available during note review so more recent vital signs can be added.",
    bg: "#fef2f2",
    color: "#ef4444",
    d: "M22 12h-4l-3 9L9 3l-3 9H2",
  },
  {
    key: "labs",
    label: "Labs",
    aliases: ["lab_results", "labs"],
    tooltip:
      "Pulls recent lab results from all instances of CPRS. Labs from the last six months will be included. Click the checkbox to include labs in the note.",
    bg: "#eff6ff",
    color: "#3b82f6",
    d: "M9 3v11|M15 3v11|M6 14h12a3 3 0 01-3 3H9a3 3 0 01-3-3z|M12 17v4|M8 21h8",
  },
  {
    key: "medications",
    label: "Medications",
    aliases: ["medications"],
    tooltip:
      "Pulls active VA and non-VA medications from all instances of CPRS. Click the checkbox to include medications in the note. Medication updates made during the visit will be reflected in the note.",
    bg: "#fefce8",
    color: "#eab308",
    d: "M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-7.5 9h9",
  },
  {
    key: "allergies",
    label: "Allergies",
    aliases: ["allergies"],
    tooltip:
      "Pulls patient allergies from all instances of CPRS. Click the checkbox to include allergies in the note. If there are no allergies, the note will state “No known allergies.” Updates made during the visit will be reflected in the note.",
    bg: "#fff1f2",
    color: "#f43f5e",
    d: "M12 9v4|M12 17h.01|M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z",
  },
  {
    key: "past_medical_history",
    label: "Active Problems",
    aliases: ["past_medical_history", "problems"],
    tooltip:
      "Pulls the active problem list from all instances of CPRS. Click the checkbox to include the problem list. Updates made during the visit will be reflected in the note.",
    bg: "#faf5ff",
    color: "#a855f7",
    d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2|R9,3,6,4,1|M9 14l2 2 4-4",
  },
];

export const DISCLAIMER =
  "Patient or surrogate consented to the use of the AI Scribe. Provider is responsible for reviewing and confirming the accuracy of this note.";
